import styled from '@emotion/styled'

const StyledLabel = styled.div`
  color: #526484;
  opacity: ${(props) => {
    const { disabled } = props
    if (disabled === true) {
      return '0.5'
    }
    return '1'
  }};
  margin-left: 0.75rem;
  zoom: ${(props) => {
    const { size } = props
    if (size === 'lg') {
      return '133%'
    }
    if (size === 'sm') {
      return '75%'
    }
    return '100%'
  }};
  font-size: 14px;
  /* border:1px solid pink; */
`
export default StyledLabel
